<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.supplierId" :getMethod="getSupplierById"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]"
    :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";

export default {
  name: "ViewSupplierContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.Supplier
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.supplierId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.SupplierChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>